module.exports = __webpack_public_path__ + "static/media/stockhausen_hbk_06.04685b30.jpg";